/*
 * This file is auto-generated. Do not modify it manually!
 */
import React from 'react';

import clsx from '@proton/utils/clsx';

import { MIME_ICON_VIEWBOX, type MimeIconComponentProps, getMimeIconAsset } from '../component';

export const MimeXls = ({ alt, title, size = 4, className, ...rest }: MimeIconComponentProps) => {
    const asset = getMimeIconAsset(size);

    return (
        <>
            <svg
                role="img"
                viewBox={MIME_ICON_VIEWBOX[asset]}
                focusable="false"
                className={clsx(`icon-size-${size}`, className)}
                {...rest}
            >
                {title ? <title>{title}</title> : null}
                {asset === 'sm' && (
                    <g>
                        <rect width="16" height="16" rx="2" fill="#29A349"></rect>
                        <path
                            d="M10.7998 6.4842C10.7998 6.33886 10.682 6.22104 10.5366 6.22104H6.74717V5.06315C6.74717 4.91781 6.62935 4.79999 6.48402 4.79999C6.33868 4.79999 6.22086 4.91781 6.22086 5.06315V6.22104H5.06296C4.91762 6.22104 4.7998 6.33886 4.7998 6.4842C4.7998 6.62954 4.91762 6.74736 5.06296 6.74736H6.22086V10.5368C6.22086 10.6822 6.33868 10.8 6.48402 10.8C6.62935 10.8 6.74717 10.6822 6.74717 10.5368V6.74736H10.5366C10.682 6.74736 10.7998 6.62954 10.7998 6.4842Z"
                            fill="white"
                        ></path>
                    </g>
                )}
                {asset === 'md' && (
                    <g>
                        <path
                            d="M0 2.5C0 1.11929 1.11929 0 2.5 0H21.5C22.8807 0 24 1.11929 24 2.5V21.5C24 22.8807 22.8807 24 21.5 24H2.5C1.11929 24 0 22.8807 0 21.5V2.5Z"
                            fill="#29A349"
                        ></path>
                        <path
                            d="M16.8999 9.34739C16.8999 9.09305 16.6937 8.88687 16.4394 8.88687H9.8078V6.86055C9.8078 6.60621 9.60161 6.40002 9.34727 6.40002C9.09293 6.40002 8.88674 6.60621 8.88674 6.86055V8.88687H6.86043C6.60609 8.88687 6.3999 9.09305 6.3999 9.34739C6.3999 9.60173 6.60609 9.80792 6.86043 9.80792H8.88674V16.4395C8.88674 16.6938 9.09293 16.9 9.34727 16.9C9.60161 16.9 9.8078 16.6938 9.8078 16.4395V9.80792H16.4394C16.6937 9.80792 16.8999 9.60173 16.8999 9.34739Z"
                            fill="white"
                        ></path>
                    </g>
                )}
                {asset === 'lg' && (
                    <g>
                        <path
                            d="M3.38989 7.82502C3.38989 4.03082 6.4657 0.955017 10.2599 0.955017H27.948C29.7182 0.955017 31.4201 1.63835 32.6988 2.86253L42.4907 12.2369C43.8444 13.5328 44.6099 15.3254 44.6099 17.1994V42.175C44.6099 45.9692 41.5341 49.045 37.7399 49.045H10.2599C6.4657 49.045 3.38989 45.9692 3.38989 42.175V7.82502Z"
                            fill="#29A349"
                        ></path>
                        <path
                            d="M44.4743 15.84H35.4501C32.2883 15.84 29.7251 13.2768 29.7251 10.115V1.18878C30.8323 1.48528 31.8573 2.05674 32.699 2.86252L42.491 12.2369C43.5123 13.2146 44.1988 14.4751 44.4743 15.84Z"
                            fill="#44D273"
                        ></path>
                        <path
                            d="M44.6101 17.5575H35.4501C31.3397 17.5575 28.0076 14.2254 28.0076 10.115V0.955261C28.5922 0.960314 29.169 1.03987 29.7251 1.18877V10.115C29.7251 13.2768 32.2882 15.84 35.4501 15.84H44.4743C44.5639 16.2841 44.6101 16.7393 44.6101 17.1993V17.5575Z"
                            fill="#008216"
                        ></path>
                        <path
                            d="M31 26.2105C31 25.8472 30.7055 25.5526 30.3421 25.5526H20.8684V22.6579C20.8684 22.2945 20.5739 22 20.2105 22C19.8472 22 19.5526 22.2945 19.5526 22.6579V25.5526H16.6579C16.2945 25.5526 16 25.8472 16 26.2105C16 26.5739 16.2945 26.8684 16.6579 26.8684H19.5526V36.3421C19.5526 36.7055 19.8472 37 20.2105 37C20.5739 37 20.8684 36.7055 20.8684 36.3421V26.8684H30.3421C30.7055 26.8684 31 26.5739 31 26.2105Z"
                            fill="white"
                        ></path>
                    </g>
                )}
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
